import React from 'react';
import PropTypes from 'prop-types';
import { Drawer, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PreviouslyOrderedColumn from '../order/PreviouslyOrderedColumn';
import { cloudinaryFull } from '../../../../utils/formatCloudinary';
import { fCurrency } from '../../../../utils/formatNumber';
import AddToCartButton from './AddToCartButton';

ItemDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  selectedItem: PropTypes.object,
  editingItemId: PropTypes.number,
  setEditingItemId: PropTypes.func,
};

export default function ItemDrawer({
  open,
  onClose,
  selectedItem,
  editingItemId,
  setEditingItemId
}) {

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: 350, p: 3, position: 'relative' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="subtitle1" fontWeight="600">
            Item Details
          </Typography>
          <IconButton onClick={onClose} size="small" sx={{ color: 'text.secondary' }}>
            <CloseIcon />
          </IconButton>
        </Box>

        {selectedItem ? (
          <>
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
              <Box
                component="img"
                src={
                  selectedItem.productDetails[0]?.pictures?.length
                    ? cloudinaryFull(selectedItem.productDetails[0].pictures[0])
                    : cloudinaryFull(
                        'https://res.cloudinary.com/agoraserv/image/upload/v1738258682/No%20Image%20Animation.gif'
                      )
                }
                alt={selectedItem.description}
                sx={{ maxHeight: 180, maxWidth: '100%', objectFit: 'contain', borderRadius: 1 }}
              />
            </Box>

            <Typography variant="body2">
              <strong>Description:</strong> {selectedItem.description}
            </Typography>
            <Typography variant="body2">
              <strong>Manufacturer:</strong> {selectedItem.productDetails[0]?.manufacturer || []}
            </Typography>

            <Typography variant="body2">
              <strong>Price:</strong> {fCurrency(selectedItem.productDetails[0]?.price)}
            </Typography>

            <Typography variant="body2">
              <strong>UOM:</strong>{' '}
              {selectedItem.productDetails[0]?.uomAmount && selectedItem.productDetails[0]?.uomType
                ? `${selectedItem.productDetails[0].uomAmount}/${selectedItem.productDetails[0].uomType}`
                : []}
            </Typography>

            <Typography variant="body2">
              <strong>SKU:</strong> <Box
                component={selectedItem.productDetails[0]?.vendorItemLink ? "a" : "span"}
                href={selectedItem.productDetails[0]?.vendorItemLink}
                target="_blank"
                rel="noreferrer"
              >
                {selectedItem.productDetails[0]?.vendorItemId}
              </Box>
            </Typography>

            <Typography variant="body2">
              <strong>Base UOM:</strong>{' '}
              {selectedItem.productDetails[0]?.baseUomAmount && selectedItem.productDetails[0]?.baseUomType
                ? `${selectedItem.productDetails[0].baseUomAmount} ${selectedItem.productDetails[0].baseUomType}`
                : []}
            </Typography>

            <Typography variant="body2">
              <strong>PS#:</strong>{' '}
              PS{selectedItem.id}
            </Typography>

            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, alignItems: 'center' }}>
              <Typography variant="body2">
                <strong>Item history:</strong>
              </Typography>
              <PreviouslyOrderedColumn
                sx={{ fontSize: '0.875rem' }}
                previouslyOrderedItems={selectedItem.productDetails[0].previouslyOrderedItems || []}
              />
            </Box>

            <Typography variant="body2">
              <strong>Vendor:</strong> {selectedItem.productDetails[0]?.vendor || []}
            </Typography>
            
            <Box sx={{mt: 2}}>
              <AddToCartButton item={selectedItem} editingItemId={editingItemId} setEditingItemId={setEditingItemId} />
            </Box>
          </>
        ) : (
          <Typography>Loading...</Typography>
        )}
      </Box>
    </Drawer>
  );
}
